<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-people />
        {{ $t('출장자를 확인하세요.') }}
      </v-col>
    </v-row>

    <!-- 추가버튼 -->
    <v-row class="ma-0 mb-3 mt-5">
      <v-col cols="12" class="py-0 px-6">
        <v-btn
          color="white"
          block
          height="48"
          elevation="0"
          class="btn-add"
          @click="onOffModal(callModalName)"
        >
          {{ $t('출장 동행인 추가') }}
          <v-icon class="ml-auto" color="#a4abb2">mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- 동행인 리스트 -->
    <v-row class="ma-0 overflow-y-auto" :style="scrollViewStyle">
      <v-col class="px-6 pt-2">
        <v-list class="order-list">
          <!-- 고정값 : 신청자본인 -->
          <v-list-item class="px-4">
            <v-col
              cols="2"
              class="d-flex justify-center"
              :class="GET_BIZ_TRIP_SABUN_NOTE ? 'px-0 py-1' : 'pa-0'"
            >
              <v-chip class="step mr-2 draft">{{ $t('신청자') }}</v-chip>
            </v-col>

            <v-col
              cols="10"
              :class="GET_BIZ_TRIP_SABUN_NOTE ? 'px-0 py-1' : 'pa-0'"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <span class="join-name">{{ GET_USER_INFO.name }}</span>
                  <span class="join-desc ml-3">{{
                    GET_USER_INFO.jikchakNm
                  }}</span>
                  <span class="join-desc divider">{{
                    GET_USER_INFO.orgNm
                  }}</span>
                </v-list-item-title>

                <v-text-field
                  v-if="GET_BIZ_TRIP_SABUN_NOTE"
                  :value="GET_BIZ_TRIP_SABUN_NOTE.userNote"
                  @input="
                    val => {
                      GET_BIZ_TRIP_SABUN_NOTE.userNote = val;
                    }
                  "
                  placeholder="내용을 작성해주세요"
                  class="shadow-none pa-0 sabun-note-input"
                  single-line
                  hide-details
                />
              </v-list-item-content>
            </v-col>
          </v-list-item>

          <!-- 추가값 : 동행인 -->
          <v-list-item-group v-for="item in joinEmpList" :key="item.sabun">
            <v-list-item class="px-4 d-flex align-center">
              <v-col
                cols="2"
                class="d-flex justify-center"
                :class="GET_BIZ_TRIP_SABUN_NOTE ? 'px-0 py-1' : 'pa-0'"
                @click="deleteEmp(item)"
              >
                <v-list-item-icon style="width: auto; padding: 0">
                  <v-icon>mdi-close</v-icon>
                </v-list-item-icon>
              </v-col>

              <v-col
                cols="10"
                :class="GET_BIZ_TRIP_SABUN_NOTE ? 'px-0 py-1' : 'pa-0'"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="join-name" v-text="item.name"></span>
                    <span class="join-desc ml-3" v-text="item.jikchakNm"></span>
                    <span class="join-desc divider" v-text="item.orgNm"></span>
                  </v-list-item-title>

                  <v-text-field
                    v-if="GET_BIZ_TRIP_SABUN_NOTE"
                    :value="item.sabunNote"
                    @input="val => (item.sabunNote = val)"
                    placeholder="내용을 작성해주세요"
                    class="shadow-none pa-0 sabun-note-input"
                    single-line
                    hide-details
                  />
                </v-list-item-content>
              </v-col>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

    <!-- [모달] 임직원검색 -->
    <search-executives-multi-dialog
      v-on:applySelectedData="addEmpList"
      v-bind:existEmpList="joinEmpList"
    ></search-executives-multi-dialog>

    <!-- 다음버튼 -->
    <next-btn @next="nextStep()" />
  </div>
</template>

<script>
/*
 * 출장신청 : 동행인 입력 화면
 *  - 동행인 추가/삭제 기능
 *  - 임직원검색 모달(ver2) 호출
 */
/* components */
import NextBtn from '@/components/application/buttons/AppNextBtn.vue';
import SearchExecutivesMultiDialog from '@/components/application/dialog/SearchExecutivesMultiDialog.vue';
import IconPeople from '@/assets/customIcon/IconPeople.vue';

/* constants */
import routerNames from '@/const/routerConstants';

import { mapGetters } from 'vuex';

export default {
  data: () => ({
    callModalName: 'search_executives_multi',

    joinEmpList: [], // 동행인목록
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_USER_INFO',
      'GET_BIZ_TRIP_JOINER',
      'GET_BIZ_TRIP_SABUN_NOTE',
    ]),

    scrollViewStyle() {
      const searchAreaHeight = 72;

      return `max-height: ${
        window.innerHeight -
        this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN -
        searchAreaHeight
      }px;`;
    },
  },

  watch: {
    GET_BIZ_TRIP_JOINER: {
      handler(val) {
        if (val) {
          this.joinEmpList = val;
        }
      },
      immediate: true,
    },
  },

  methods: {
    /* 임직원목록 추가 */
    addEmpList(empList) {
      // 1. 추가목록에 신청자 본인이 있는 경우 제거
      empList = empList.filter(emp => emp.sabun !== this.GET_USER_INFO.sabun);

      // 2. 동행인목록에 추가
      this.joinEmpList = this.joinEmpList.concat(empList);
    },

    /* 임직원 삭제 */
    deleteEmp(employee) {
      this.joinEmpList.forEach((item, index) => {
        if (item.sabun == employee.sabun) {
          this.joinEmpList.splice(index, 1);
        }
      });
    },

    /* 모달호출 */
    onOffModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },

    /* 추가항목 필수체크 */
    checkRequired() {
      // 신청자
      if (this.GET_BIZ_TRIP_SABUN_NOTE.userNote == '') {
        return false;
      }

      // 추가동행인
      for (const emp of this.joinEmpList) {
        if (!emp.sabunNote || emp.sabunNote == '') {
          return false;
        }
      }

      return true;
    },

    /* 다음 */
    async nextStep() {
      // 1. sabunNote(추가내용) 필수일 경우 입력값 체크
      if (
        this.GET_BIZ_TRIP_SABUN_NOTE &&
        this.GET_BIZ_TRIP_SABUN_NOTE.requiredYn === 'Y' &&
        !this.checkRequired()
      ) {
        alert('추가내용을 작성해주세요.');
        return;
      }

      // 2. 입력한 동행인목록 스토어에 저장해두기
      this.$store.commit('ELA/SET_BIZ_TRIP_JOINER', this.joinEmpList);

      // (25.7.7) 3. 키보드 활성상태에서 다음화면 이동 시 화면깨짐문제 해결
      // 3-1. 강제로 포커스 해제
      document.activeElement?.blur();

      // 3-2. 뷰포트 복원을 위해 키보드 애니메이션 종료까지 대기
      await this.waitForKeyboardToSettle();

      // 4. 다음화면으로 이동
      this.$router.push(routerNames.ExtraOptions);
    },

    /* 키보드 애니메이션이 끝날 때까지 대기) */
    waitForKeyboardToSettle() {
      return new Promise(resolve => {
        setTimeout(resolve, 300); // 300~500ms 정도 테스트해보고 조정
      });
    },
  },

  components: {
    NextBtn,
    SearchExecutivesMultiDialog,
    IconPeople,
  },
};
</script>

<style scoped lang="scss">
.v-btn.btn-add {
  border-radius: 12px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  font-size: 1rem;
}

.join-name {
  font-weight: bold;
  line-height: 1.5;
  color: #363c43;
  font-size: 1rem;
}
.join-desc {
  font-size: 0.875rem;
  color: #505961;
}
.sabun-note-input {
  color: #505961;
}
</style>
